export class OrderNotFoundError extends Error {}
